<!-- deviceListing starts -->
<div class="echo-responsive-header" *ngIf="pageType === 'device-listing'">
  <mat-card class="e-tiles">
    <span class="fit-content d-flex align-items-center gap10">
      <span class="violet-bg d-flex align-items-center justify-content-center fit-content">
        <img src=".././../../../assets/images/device_hub.svg">
      </span>
      <span>Total Count</span> </span>
    <h4>{{ devicesSummaryDetails?.totalDevices }}</h4>
  </mat-card>
  <mat-card class="e-tiles">
    <span class="fit-content d-flex align-items-center gap10">
      <span class="green-bg d-flex align-items-center justify-content-center fit-content">
        <img src=".././../../../assets/images/attached-metrics.svg">
      </span>
      <span>Attached</span> </span>
    <h4>{{ devicesSummaryDetails?.mappedDevices }}</h4>
  </mat-card>
  <mat-card class="e-tiles">
    <span class="fit-content d-flex align-items-center gap10">
      <span class="running-icon-bg d-flex align-items-center justify-content-center fit-content">
        <img src=".././../../../assets/images/play_arrow.svg">
      </span>
      <span>Running</span> </span>
    <h4>{{ devicesSummaryDetails?.running }}</h4>
  </mat-card>
  <mat-card class="e-tiles">
    <span class="fit-content d-flex align-items-center gap10">
      <span class="not-running-bg d-flex align-items-center justify-content-center fit-content">
        <img src=".././../../../assets/images/stop_circle.svg">
      </span>
      <span>Not Running</span> </span>
    <h4>{{ devicesSummaryDetails?.notRunning }}</h4>
  </mat-card>
</div>
<!-- deviceListing ends -->
<!-- templateListing -->
<div class="echo-responsive-header" *ngIf="pageType === 'template-listing'">
  <mat-card class="e-tiles">
    <span class="fit-content d-flex align-items-center gap10">
      <span class="violet-bg d-flex align-items-center justify-content-center fit-content">
        <img src=".././../../../assets/images/device_hub.svg">
      </span>
      <span>Total Count</span> </span>
    <h4>{{ templatesSummaryDetails?.totalTemplates }}</h4>
  </mat-card>
  <mat-card class="e-tiles">
    <span class="fit-content d-flex align-items-center gap10">
      <span class="green-bg d-flex align-items-center justify-content-center fit-content">
        <img src=".././../../../assets/images/attached-metrics.svg">
      </span>
      <span>In Use</span> </span>
    <h4>{{ templatesSummaryDetails?.mappedTemplates }}</h4>
  </mat-card>
  <mat-card class="e-tiles">
    <span class="fit-content d-flex align-items-center gap10">
      <span class="bg-grey d-flex align-items-center justify-content-center fit-content">
        <img src=".././../../../assets/images/batch_untag_icon.svg">
      </span>
      <span>Not In Use</span> </span>
    <h4>{{ templatesSummaryDetails?.totalTemplates - templatesSummaryDetails?.mappedTemplates }}</h4>
  </mat-card>
</div>

<div class="echo-responsive-header" *ngIf="pageType=== 'batch-listing'">
  <mat-card class="e-tiles">
    <span class="fit-content d-flex align-items-center gap10">
      <span class="violet-bg d-flex align-items-center justify-content-center fit-content">
        <img src=".././../../../assets/images/device_hub.svg">
      </span>
      <span>Total Count</span> </span>
    <h4>{{ batchesSummaryDetails?.totalBatches }}</h4>
  </mat-card>
  <mat-card class="e-tiles">
    <span class="fit-content d-flex align-items-center gap10">
      <span class="green-bg d-flex align-items-center justify-content-center fit-content">
        <img src=".././../../../assets/images/scheduled_icon.svg">
      </span>
      <span>Scheduled</span> </span>
    <h4>{{ batchesSummaryDetails?.scheduledBatches }}</h4>
  </mat-card>
  <mat-card class="e-tiles">
    <span class="fit-content d-flex align-items-center gap10">
      <span class="running-icon-bg d-flex align-items-center justify-content-center fit-content">
        <img src=".././../../../assets/images/play_arrow.svg">
      </span>
      <span>Running</span> </span>
    <h4>{{ batchesSummaryDetails?.runningBatches }}</h4>
  </mat-card>
</div>